<template>
  <b-modal v-model="isModalActive" :id="'sideBar' + $store.state.sidebar" :can-cancel="false">
    <div class="form-modal-widget">
      <div class="form-modal-header">
        <h1 v-if="!form.id">ADD NEW VOTING PARTICIPANT</h1>
        <h1 v-else>EDIT VOTING PARTICIPANT</h1>
      </div>

      <div class="form-modal-body">
        <div class="row">
          <b-field label="Name" style="width: 100%">
            <b-input v-model="form.name"></b-input>
          </b-field>
        </div>

        <b-field label="Bio">
          <b-input v-model="form.bio" type="textarea" placeholder="Enter participant bio"></b-input>
        </b-field>

        <div class="row">
          <b-field label="Phone" style="width: 48%; margin-right: 4%">
            <b-input v-model="form.phone" placeholder="+250..."></b-input>
          </b-field>
          <b-field label="Email" style="width: 48%">
            <b-input v-model="form.email" type="email" placeholder="email@example.com"></b-input>
          </b-field>
        </div>

        <b-field label="Password">
          <b-input v-model="form.password" type="password" placeholder="Enter password"></b-input>
        </b-field>

        <b-field label="Profile image">
          <upload-trigger :open="false" :enableinput="false" :required="false" :multiple="false"
            location="assets/uploaded/" :url="$store.state.ASSETS_BASE_URL"
            :uploadurl="$store.state.BASE_URL + 'upload'" name="main-image" :value="form.image" @onFileSelected="
              (file) => {
                form.image = file;
              }
            ">
            <div class="image-upload-widget">Choose Image to upload</div>
          </upload-trigger>
        </b-field>

        <div class="social-media-section">
          <h4>Social Media Links & Followers</h4>

          <div class="row">
            <b-field label="Facebook URL" style="width: 65%; margin-right: 5%">
              <b-input v-model="form.facebook_url" placeholder="https://facebook.com/username"></b-input>
            </b-field>
            <b-field label="Followers" style="width: 30%">
              <b-numberinput v-model="form.facebook_followers" expanded min="0" controls-position="compact"
                placeholder="0"></b-numberinput>
            </b-field>
          </div>

          <div class="row">
            <b-field label="Twitter URL" style="width: 65%; margin-right: 5%">
              <b-input v-model="form.twitter_url" placeholder="https://twitter.com/username"></b-input>
            </b-field>
            <b-field label="Followers" style="width: 30%">
              <b-numberinput v-model="form.twitter_followers" expanded min="0" controls-position="compact"
                placeholder="0"></b-numberinput>
            </b-field>
          </div>

          <div class="row">
            <b-field label="Instagram URL" style="width: 65%; margin-right: 5%">
              <b-input v-model="form.instagram_url" placeholder="https://instagram.com/username"></b-input>
            </b-field>
            <b-field label="Followers" style="width: 30%">
              <b-numberinput v-model="form.instagram_followers" expanded min="0" controls-position="compact"
                placeholder="0"></b-numberinput>
            </b-field>
          </div>

          <div class="row">
            <b-field label="Threads URL" style="width: 65%; margin-right: 5%">
              <b-input v-model="form.threads_url" placeholder="https://threads.net/username"></b-input>
            </b-field>
            <b-field label="Followers" style="width: 30%">
              <b-numberinput v-model="form.threads_followers" expanded min="0" controls-position="compact"
                placeholder="0"></b-numberinput>
            </b-field>
          </div>

          <div class="row">
            <b-field label="TikTok URL" style="width: 65%; margin-right: 5%">
              <b-input v-model="form.tiktok_url" placeholder="https://tiktok.com/@username"></b-input>
            </b-field>
            <b-field label="Followers" style="width: 30%">
              <b-numberinput v-model="form.tiktok_followers" expanded min="0" controls-position="compact"
                placeholder="0"></b-numberinput>
            </b-field>
          </div>

          <div class="row">
            <b-field label="YouTube URL" style="width: 65%; margin-right: 5%">
              <b-input v-model="form.youtube_url" placeholder="https://youtube.com/channel/..."></b-input>
            </b-field>
            <b-field label="Followers" style="width: 30%">
              <b-numberinput v-model="form.youtube_followers" expanded min="0" controls-position="compact"
                placeholder="0"></b-numberinput>
            </b-field>
          </div>
        </div>

        <b-field label="Visibility" style="width: 100%">
          <b-select v-model="form.status" placeholder="Select a visibility" expanded>
            <option v-for="option in visibilities" :value="option.value" :key="option.value">
              {{ option.name }}
            </option>
          </b-select>
        </b-field>

        <b-field label="Code">
          <b-numberinput v-model="form.item_index" expanded min="1" controls-position="compact"></b-numberinput>
        </b-field>
      </div>

      <div class="form-modal-footer">
        <b-button :loading="submit_loading" @click="submitForm()" type="is-primary">
          SUBMIT
        </b-button>
        <b-button @click="onCancel" type="is-primary" outlined>CANCEL</b-button>
      </div>
    </div>
  </b-modal>
</template>
<script>
export default {
  components: {},
  props: {
    session_id: {
      type: Number,
      default: null,
    },
    category_id: {
      type: Number,
      default: null,
    },
    value: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    isModalActive: true,
    visibilities: [
      {
        value: "public",
        name: "Public",
      },
      {
        value: "unlisted",
        name: "Unlisted",
      },
    ],
    form: {
      id: null,
      session_id: null,
      category_id: null,
      name: "",
      bio: "",
      phone: "",
      email: "",
      password: "",
      image: "",
      facebook_url: "",
      facebook_followers: 0,
      twitter_url: "",
      twitter_followers: 0,
      instagram_url: "",
      instagram_followers: 0,
      threads_url: "",
      threads_followers: 0,
      tiktok_url: "",
      tiktok_followers: 0,
      youtube_url: "",
      youtube_followers: 0,
      item_index: 0,
      status: "unlisted",
    },
    submit_loading: false,
  }),
  watch: {},
  mounted() {
    let vm = this;
    if (vm.value) {
      vm.setFormFields();
    } else {
      vm.resetFormFields();
    }
  },
  beforeDestroy() {
    let vm = this;
  },
  methods: {
    setFormFields() {
      let vm = this;
      vm.form.id = vm.value.id;
      vm.form.session_id = vm.value.voting_session_id;
      vm.form.category_id = vm.value.voting_category_id;
      vm.form.name = vm.value.name;
      vm.form.bio = vm.value.bio || "";
      vm.form.phone = vm.value.phone || "";
      vm.form.email = vm.value.email || "";
      vm.form.password = "";
      vm.form.image = vm.value.profile_image;
      vm.form.facebook_url = vm.value.facebook_url || "";
      vm.form.facebook_followers = parseInt(vm.value.facebook_followers) || 0;
      vm.form.twitter_url = vm.value.twitter_url || "";
      vm.form.twitter_followers = parseInt(vm.value.twitter_followers) || 0;
      vm.form.instagram_url = vm.value.instagram_url || "";
      vm.form.instagram_followers = parseInt(vm.value.instagram_followers) || 0;
      vm.form.threads_url = vm.value.threads_url || "";
      vm.form.threads_followers = parseInt(vm.value.threads_followers) || 0;
      vm.form.tiktok_url = vm.value.tiktok_url || "";
      vm.form.tiktok_followers = parseInt(vm.value.tiktok_followers) || 0;
      vm.form.youtube_url = vm.value.youtube_url || "";
      vm.form.youtube_followers = parseInt(vm.value.youtube_followers) || 0;
      vm.form.item_index = parseInt(vm.value.item_index);
      vm.form.status = vm.value.status;
    },
    resetFormFields() {
      let vm = this;
      vm.form = {
        id: null,
        session_id: null,
        category_id: null,
        name: "",
        bio: "",
        phone: "",
        email: "",
        password: "",
        image: "",
        facebook_url: "",
        facebook_followers: 0,
        twitter_url: "",
        twitter_followers: 0,
        instagram_url: "",
        instagram_followers: 0,
        threads_url: "",
        threads_followers: 0,
        tiktok_url: "",
        tiktok_followers: 0,
        youtube_url: "",
        youtube_followers: 0,
        item_index: 0,
        status: "unlisted",
      };
    },
    submitForm() {
      let vm = this;
      // Start validate
      const rules = {
        name: {
          run: (value) => {
            if (!value) {
              return "Name is required";
            }
            return false;
          },
        },
      };
      if (vm.$isFieldsValidated(vm.form, rules)) {
        vm.submit_loading = true;
        vm.form.session_id = vm.session_id;
        vm.form.category_id = vm.category_id;
        if (!vm.form.id) {
          vm.$store
            .dispatch("VOTING_ADDNEW_VOTING_PARTICIPANT", vm.form)
            .then((response) => {
              vm.submit_loading = false;
              vm.$emit("saved", response.data.return);
              vm.$notify({
                group: "status",
                type: "success",
                title: "Important message",
                text: response.data.message,
              });
            })
            .catch(({ response }) => {
              vm.submit_loading = false;
              vm.$notify({
                group: "status",
                type: "warn",
                title: "OOPS!!!",
                text: response.data.message,
              });
            });
        } else {
          vm.$store
            .dispatch("VOTING_UPDATE_VOTING_PARTICIPANT", vm.form)
            .then((response) => {
              vm.submit_loading = false;
              vm.$emit("saved", response.data.return);
              vm.$notify({
                group: "status",
                type: "success",
                title: "Important message",
                text: response.data.message,
              });
            })
            .catch(({ response }) => {
              vm.submit_loading = false;
              vm.$notify({
                group: "status",
                type: "warn",
                title: "OOPS!!!",
                text: response.data.message,
              });
            });
        }
      }
    },
    onCancel() {
      let vm = this;
      vm.$emit("close");
    },
  },
};
</script>
<style lang="scss" scoped>
.form-modal-widget {
  width: 800px;
  background: #fff;
  margin: 20px auto;
  border-radius: 5px;

  @media (max-width: 900px) {
    width: 95% !important;
  }

  @media (max-width: 628px) {
    width: 95% !important;

    .row {
      flex-direction: column;
      align-items: stretch !important;

      .field {
        width: 100% !important;
        margin-right: 0 !important;
      }
    }
  }

  @media (max-width: 500px) {
    width: 100% !important;
    margin: 0;
  }

  .form-modal-header {
    height: 60px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #ddd;
    padding: 0px 20px;
    justify-content: space-between;

    @media (max-width: 500px) {
      position: sticky;
      top: 0;
      z-index: 10;
      background: white;
    }
  }

  .form-modal-body {
    padding: 10px 20px;
    min-height: 200px;
    padding-bottom: 30px;

    .row {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      margin-bottom: 15px;
    }

    .social-media-section {
      background: #f8f9fa;
      padding: 15px;
      border-radius: 8px;
      margin: 20px 0;

      h4 {
        margin-bottom: 15px;
        color: #333;
        font-size: 16px;
        font-weight: 600;
      }
    }

    .image-upload-widget {
      padding: 20px;
      border: 2px dashed #ddd;
      border-radius: 8px;
      text-align: center;
      cursor: pointer;
      background: #f8f9fa;
      transition: all 0.3s ease;

      &:hover {
        border-color: #3273dc;
        background: #f0f8ff;
      }
    }
  }

  .form-modal-footer {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #ddd;
    padding: 0px 20px;
  }
}

#sideBartrue {
  left: 230px;

  @media (max-width: 768px) {
    left: 0;
  }

  .form-modal-widget {
    @media (max-width: 1100px) {
      width: 700px;
    }

    @media (max-width: 846px) {
      width: 600px;
    }

    @media (max-width: 768px) {
      width: 95%;
    }
  }
}
</style>